const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

const Modal = require('app/ui/Modal');
const ConfirmModal = require('app/ui/modal/Confirm');
const ListTable = require('app/ui/list/Table');

const AssociationModal = require('app/restaurant/supplier/AssociationModal');
const DeliveryModal = require('app/restaurant/supplier/DeliveryModal');
const RangeModal = require('app/restaurant/supplier/RangeModal');


class SupplierTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$list = $('<div/>');

        this.$container
        .html('')
        .addClass('white-box p-2')
        .append(this.$list);

        this.loadData();
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildSupplierAssociationQuery(),
            this.buildSupplierQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildList(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierAssociationQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'first': 10000,
            'filter': {
                'restaurant': id
            }
        };

        let fields = [
            'supplier { id name }',
            'deliveries { day orderMaxDay }',
            'customerCodes { code }',
            'rangeAssociations { range { id name } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantSupplierAssociations',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }


    buildSupplierQuery(){
        var self = this;

        let parameters = {
            'first': 10000,
            'orderBy': 'name',
            'dir': "ASC",
            'filter': {
                'enable': true
            }
        };

        let fields = [
            'id',
            'name'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'suppliers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    compileData(data){
        this.supplierAssociations = data.restaurantSupplierAssociations.edges;
        this.suppliers = data.suppliers.edges;

        this.compiledData = [];
        for(var i in this.suppliers){
            let supplier = this.suppliers[i].node;

            let currentLine = {
                'supplier': supplier,
                'association': null,
            };
            for(var j in this.supplierAssociations){
                let supplierAssociation = this.supplierAssociations[j].node;
                if(supplier.id == supplierAssociation.supplier.id){
                    currentLine.association = supplierAssociation;
                }
            }

            this.compiledData.push(currentLine);
        }
        return this.compiledData;
    }

    buildList(data){
        var self = this;
        this.compileData(data);

        this.$list.html('');

        this.table = new ListTable({
            '$container': this.$list,
            'tableClass': 'table table-striped restaurant-user-list',
            'id': 'list-users',
            'length': 50,
            'data': this.compiledData,
            'columns': [
                {
                    'name': 'name',
                    'label': window.translate('app.restaurant.show.tabs.supplier.name.label'),
                    'class': 'supplier-name',
                    'render': function(item,index){
                        return item.supplier.name;
                    },
                },
                {
                    'name': 'enable',
                    'label': window.translate('app.restaurant.show.tabs.supplier.enable.label'),
                    'class': 'supplier-enable',
                    'render': function(item,index){

                        let $checkbox = $('<input/>')
                        .addClass('supplier-checkbox-enable')
                        .attr('data-id',item.supplier.id)
                        .attr('type','checkbox')
                        .addClass('form-check-input form-check-input-checked-success form-check-input-unchecked-danger')
                        .on('change',function(){
                            let $checkbox = $(this);
                            self.onChangeEnableSupplier(item,$checkbox.is(':checked'));
                        });
                        if( item.association != null){
                            $checkbox.prop('checked',true);
                        }
                        let $item = $('<div/>')
                        .addClass('form-check form-switch')
                        .append($checkbox);
                        return $item;
                    },
                },
                {
                    'name': 'code',
                    'label': window.translate('app.restaurant.show.tabs.supplier.code.label'),
                    'class': 'supplier-code',
                    'render': function(item,index){
                        let codes = [];
                        if(item.association != null){
                            for(var i in item.association.customerCodes){
                                let customerCode = item.association.customerCodes[i];
                                codes.push(customerCode.code);
                            }
                        }
                        return codes.join(', ');
                    },
                },
                {
                    'name': 'deliveries',
                    'label': window.translate('app.restaurant.show.tabs.supplier.deliveries.label'),
                    'class': 'supplier-deliveries',
                    'render': function(item,index){
                        let $deliveries = $('<ul/>')
                        .addClass('list-unstyled');

                        if(item.association != null){
                            for(var i in item.association.deliveries){
                                let delivery = item.association.deliveries[i];
                                let deliveryDay = delivery.day;
                                let orderDay = delivery.orderMaxDay;

                                let deliveryDayLabel = window.translate('day'+deliveryDay);
                                let orderDayLabel = window.translate('day'+orderDay);
                                let label = window.translate('app.restaurant.show.tabs.supplier.deliveries.message',{
                                    '%orderDay%' : orderDayLabel,
                                    '%deliveryDay%': deliveryDayLabel
                                })
                                $deliveries.append(
                                    $('<li/>')
                                    .append(label)
                                )
                            }
                        }
                        return $deliveries;
                    },
                },
                {
                    'name': 'ranges',
                    'label': window.translate('app.restaurant.show.tabs.supplier.ranges.label'),
                    'class': 'supplier-ranges',
                    'render': function(item,index){
                        let $ranges = $('<div/>')

                        if(item.association != null){
                            let count = item.association.rangeAssociations.length;
                            let label = window.translate('app.restaurant.show.tabs.supplier.ranges.message',{
                                '%nb%': count
                            });
                            $ranges.append(label);
                        }
                        return $ranges;
                    },
                },
                {
                    'name': 'action',
                    'label': '',
                    'class': 'user-action',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        
                        let btns = [];

                        if(item.association != null){

                            let $btnEdit = $('<button/>')
                            .attr('type','button')
                            .attr('data-id',item.supplier.id)
                            .addClass('btn btn-link btn-edit text-primary')
                            .attr('title',window.translate('app.restaurant.show.tabs.supplier.actions.edit.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-pencil')
                            )
                            .on('click',function(event){
                                self.onClickEdit(item)
                            });
                            btns.push($btnEdit);



                            let $btnEditDeliveries = $('<button/>')
                            .attr('type','button')
                            .attr('data-id',item.supplier.id)
                            .addClass('btn btn-link btn-edit-deliveries text-primary')
                            .attr('title',window.translate('app.restaurant.show.tabs.supplier.actions.editDeliveries.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-truck')
                            )
                            .on('click',function(event){
                                self.onClickEditDeliveries(item)
                            });
                            btns.push($btnEditDeliveries);


                            let $btnEditRanges = $('<button/>')
                            .attr('type','button')
                            .attr('data-id',item.supplier.id)
                            .addClass('btn btn-link btn-edit-ranges text-primary')
                            .attr('title',window.translate('app.restaurant.show.tabs.supplier.actions.editRanges.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-clipboard-list')
                            )
                            .on('click',function(event){
                                self.onClickEditRanges(item)
                            });
                            btns.push($btnEditRanges);
                        }

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                }
            ]
        });
    }

    onChangeEnableSupplier(item,checked){
        if(checked){
            this.onClickEdit(item,true);
        }else{
            this.showConfirmDisableSupplier(item);
        }
    }

    showConfirmDisableSupplier(item){
        var self = this;

        let $content = $('<div/>')
        .addClass('p-2')
        .append(
            $('<h3/>')
            .addClass('p-2')
            .append(window.translate('app.restaurant.show.tabs.supplier.disableConfirmModal.title',{
                '%supplierName%': item.supplier.name,
                '%restaurantName%': this.restaurant.name
            }))
        )
        .append(
            $('<div/>')
            .addClass('text-danger')
            .append(window.translate('app.restaurant.show.tabs.supplier.disableConfirmModal.warning',{
                '%supplierName%': item.supplier.name,
                '%restaurantName%': this.restaurant.name
            }))
        )
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(window.translate('app.restaurant.show.tabs.supplier.disableConfirmModal.confirm'))
        )

        let confirmModal = new ConfirmModal({
            'id': "restaurantSupplierDisableConfirmModal",
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-primary btn-cancel',
            'btnConfirmContent': window.translate('yes'),
            'btnCancelContent': window.translate('no'),
            'onConfirm': function(event,modal){
                self.proceedDisableSupplier(item,confirmModal);
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedDisableSupplier(item,confirmModal){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'supplier': {
                'value': item.supplier.id,
                'type': 'Int!'
            },
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurantSupplierAssociation",
            'fields': fields,
            'variables': variables,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                    confirmModal.dispose();
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                self.refresh();
            }
        });
        mutation.execute();

    }

    onClickEdit(item,onCloseRefresh){
        var self  = this;
        let modal = new AssociationModal({
            'restaurant':this.restaurant,
            'supplier': item.supplier,
            'success': function(){
                self.refresh();
                modal.dispose();
                self.onClickEditDeliveries(item);
            },
            'onClose': function(){
                if(modal.hasChange()){
                    self.showConfirmCancelChangeModal(
                        item.supplier,
                        function(){
                            //do nothing if confirmed
                            if (onCloseRefresh){
                                self.refresh();
                            }
                        },
                        function(){
                            modal.show();
                        }
                    );
                }else if (onCloseRefresh){
                    self.refresh();
                }
            }
        });
    }

    onClickEditDeliveries(item){
        var self  = this;
        let modal = new DeliveryModal({
            'restaurant':this.restaurant,
            'supplier': item.supplier,
            'success': function(){
                self.refresh();
                modal.dispose();
                self.onClickEditRanges(item);
            },
            'onClose': function(){
                if(modal.hasChange()){
                    self.showConfirmCancelChangeModal(
                        item.supplier,
                        function(){
                            //do nothing if confirmed
                        },
                        function(){
                            modal.show();
                        }
                    );
                }
            },
            'onClickBack': function(modal,form){
                modal.hide();
                if(modal.hasChange()){
                    self.showConfirmCancelChangeModal(
                        item.supplier,
                        function(){
                            self.onClickEdit(item);
                        },
                        function(){
                            modal.show();
                        }
                    );
                }else{
                    self.onClickEdit(item);
                }
            }
        });
    }
    
    onClickEditRanges(item){
        var self  = this;
        let modal = new RangeModal({
            'restaurant':this.restaurant,
            'supplier': item.supplier,
            'success': function(){
                self.refresh();
                modal.dispose();
            },
            'onClose': function(){
                if(modal.hasChange()){
                    self.showConfirmCancelChangeModal(
                        item.supplier,
                        function(){
                            //do nothing if confirmed
                        },
                        function(){
                            modal.show();
                        }
                    );
                }
            },
            'onClickBack': function(modal,form){
                modal.hide();
                if(modal.hasChange()){
                    self.showConfirmCancelChangeModal(
                        item.supplier,
                        function(){
                            self.onClickEditDeliveries(item);
                        },
                        function(){
                            modal.show();
                        }
                    );
                }else{
                    self.onClickEditDeliveries(item);
                }
            }
        });
    }

    showConfirmCancelChangeModal(supplier,callbackConfirm,callbackCancel){
        var self = this;

        let $content = $('<div/>')
        .addClass('p-2')
        .append(
            $('<h3/>')
            .addClass('p-2')
            .append(window.translate('app.restaurant.show.tabs.supplier.cancelConfirmModal.title',{
                '%supplierName%': supplier.name,
                '%restaurantName%': this.restaurant.name
            }))
        )
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(window.translate('app.restaurant.show.tabs.supplier.cancelConfirmModal.message'))
        )

        let confirmModal = new ConfirmModal({
            'id': "restaurantSupplierChangeConfirmModal",
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-primary btn-cancel',
            'btnConfirmContent': window.translate('yes'),
            'btnCancelContent': window.translate('no'),
            'onConfirm': function(event,modal){
                callbackConfirm();
            },
            'onCancel': function(event,modal){
                callbackCancel();
            }
        })
        confirmModal.show();
    }
}

module.exports = SupplierTab;

